module Meevo.Plugins.StandingAppointments {
    import AppointmentSchedule = Meevo.Model.AppointmentSchedule;
    import PassiveAlert = Meevo.Plugins.AppointmentBook.PassiveAlert;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    "use strict";

    /**
    * Main Section of Client
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<AppointmentSchedule> {
        // TODO: Move choices into constants file
        numberOfOccurrencesChoice = "1";
        endByChoice = "2";
        isPerpetualChoice = "3";
        endingChoice = this.isPerpetualChoice;
        dayOfWeekChoice = "1";
        dayOfMonthChoice = "2";
        monthlyChoice = this.dayOfWeekChoice;
        defaultEndDate: any = moment().startOf("day").toDate();
        defaultTotalOccurrences = 1;
        defaultOccurrenceInterval = 14;
        defaultDayOfMonth = 1;
        startTimeTemp: any;
        serviceCriteria:any;
        serviceAddOnPermission: boolean = false;
        requireAppointmentCategory: boolean = false;

        private readonly timeSpanFormat = "HH:mm:ss.SSSSSSS";

        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            private restServer: any,
            protected modalService: Meevo.Components.Modal.IModalService,
            private searchContextCriteria: any,
            private $http,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            private securityChecker: Meevo.Components.Common.ISecurityService,
            sectionSecurityKey: string,
            protected stepOverrideService: Meevo.Plugins.AppointmentBook.StepOverride,
            protected $q: angular.IQService,
            private context: StandingAppointmentsContext
        ) {
            super(
                sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);


            this.serviceCriteria = { isBookable: true, wildCardType: Model.FilterWildcardType.Contains };

            this.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.APPOINTMENTS_APPOINTMENTBOOK_VIEW_ADDONS).then(result => {
                this.serviceAddOnPermission = (result === Meevo.Model.SecurityAccessEnum.Grant);
            });

            this.dataService.customMethodData("api/tenant/businessInfo/settings", "get", null).then((response) => {
                let settings: Model.AppointmentBookSettings = response.data.appointmentBookSettings;
                this.requireAppointmentCategory = settings.requireAppointmentCategory;
            });
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            let instance: Model.AppointmentSchedule = {
                objectState: Meevo.Model.ObjectStateEnum.Active,
                daysOfWeek: [],
                frequency: 1,
                frequencyUnit: Meevo.Model.DateTimeUnitEnum.Week,
                occurrenceInInterval: this.defaultOccurrenceInterval,
                startDate: moment().startOf("day").toDate(),
                isPerpetual: true,
                services: [],
                defineStartTimesManually: false
            };
            this.model = instance;
            this.addService();
            this.model.client = this.searchContextCriteria ? this.searchContextCriteria.client : undefined;
            this.startTimeTemp = {
                value: moment("09:00", "HH:mm").toDate()
            };
            this.endingChoice = this.isPerpetualChoice;
        }

        handleDisabledElementClick(target, message, context = null) {
            context = context || this;
            if (context.model.hasScheduleStarted && context.mode !== Meevo.Model.MaintenanceFormState.Readonly
                && (target.is(':disabled') || target.closest('[disabled]').length > 0)
                && !context.context.isBlockedFromEditing) {
                    context.modalService.alert(message);
            }
        }

        handleNumberOfAppointmentsDisabledClick(event): void {
            event.data.context.handleDisabledElementClick($(event.target), "MESSAGE_STANDING_NUMBER_OF_APPOINTMENTS_NO_EDIT", event.data.context);
        }

        sectionModelRetrieved(): void {
            if (this.model) {
                this.$timeout(() => {
                    $("#standing-appt-main .standing-appointment-client, #standing-appt-main .standing-start-date")
                        .off("click").on("click", (event) => {
                            this.handleDisabledElementClick($(event.target), "MESSAGE_STANDING_CLIENT_STARTDATE_NO_EDIT");
                        });

                    $("#standing-appt-main .standing-appointment-frequency").off("click").on("click", (event) => {
                        this.handleDisabledElementClick($(event.target), "MESSAGE_STANDING_FREQUENCY_NO_EDIT");
                    });

                    $("#standing-appt-main .standing-number-of-appointments")
                        .off('click', this.handleNumberOfAppointmentsDisabledClick)
                        .on('click', { context: this }, this.handleNumberOfAppointmentsDisabledClick);
                }, 1000);
                
                this.startTimeTemp = { value: moment(this.model.startTime, "HH:mm").toDate() };

                this.endingChoice = this.model.isPerpetual ? this.isPerpetualChoice : this.model.endDate ? this.endByChoice : this.numberOfOccurrencesChoice;
                this.monthlyChoice = this.model.dayOfMonth ? this.dayOfMonthChoice : this.dayOfWeekChoice;

                this.model.services.forEach((scheduleService) => {
                    (<any>scheduleService).manualStartTimeTemp = scheduleService.manualStartTime || this.startTimeTemp.value;
                    this.updateEmployeeCriteria(scheduleService);
                    this.updateSteps(scheduleService, scheduleService.steps);
                    scheduleService.isRequested = scheduleService.employeeType == Model.EmployeeTypeEnum.Request;
                    this.calculateStepDuration(scheduleService);
                })
                
                if (this.model.dateUpdated) {
                    this.context.setModelDateUpdated(moment(this.model.dateUpdated).toDate());
                }
            }
        }

        createSectionModelCopy(): Model.AppointmentSchedule {
            let item = <Model.AppointmentSchedule>(this.model);
            item.isReadOnly = undefined;
            item.hasScheduleStarted = undefined;
            item.id = null;
            return item;
        }

        preSave(): void {
            this.model.clientId = this.model.client.id;
            this.model.services.forEach((scheduleService) => {
                scheduleService.employeeId = (scheduleService.employee ? scheduleService.employee.id : null);
                scheduleService.serviceId = scheduleService.service.id;
            });
            this.model.appointmentCategoryId = this.model.appointmentCategory ? this.model.appointmentCategory.id : null;


            // Need starttimetemp prop b/c if we set time back to timespan, it will cause binding
            // to control to fail
            this.model.startTime = moment(this.startTimeTemp.value).format(this.timeSpanFormat);
            this.model.services.forEach((scheduleService)=> {
                scheduleService.employeeType = scheduleService.isRequested ? Model.EmployeeTypeEnum.Request : Model.EmployeeTypeEnum.NonRequest;
                if (this.model.defineStartTimesManually) {
                    scheduleService.manualStartTime = moment((<any>scheduleService).manualStartTimeTemp).toDate();
                }
            });
        }

        showSaveWarning(): ng.IPromise<boolean> {
            if (this.isAdding || (this.model as any).suppressWarnings) {
                return this.$q.resolve(true);
            }

            return this.modalService.yellowConfirm('MESSAGE_STANDING_APPOINTMENT_SAVE_CHANGES', ModalTranslationModes.Translate, false, true)
                .then((res) => {
                    return this.$q.resolve(res);
                });
        }

        get activeState(): boolean {
            if (this.model !== undefined) {
                if (this.model.objectState === Model.ObjectStateEnum.Active) {
                    return true;
                }
            }

            return false;
        }

        set activeState(value: boolean) {
            if (this.model !== undefined) {
                if (value) {
                    this.model.objectState = Model.ObjectStateEnum.Active;
                } else {
                    if (this.model.objectState !== Model.ObjectStateEnum.Deleted) {
                        this.model.objectState = Model.ObjectStateEnum.Inactive;
                    }
                }
            }
        }

        clientChanged() {
            if (this.model.client) {
                if (this.model.client.isRestricted) {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: "app/plugins/AppointmentBook/views/Message.html",
                        controller: "meevo.plugins.appointmentBook.MessageController",
                        controllerAs: "vm",
                        bindToController: true,
                        multiple: true,
                        skipHide: true,
                        onComplete: undefined,
                        locals: { message: "MESSAGE_CLIENT_RESTRICTED", config: { messageClass: "high" } }
                    }
                    this.modalService.showCustom(options, ModalTranslationModes.Translate);
                }
                this.model.doNotConfirm = this.model.client.doNotConfirm;
                this.checkServiceAndClientGenderConflict(true, this.model.services);
                this.getSteps(this.model.services);
            }
        }

        serviceChanged(scheduleService) {
            scheduleService.steps = undefined;
            scheduleService.hasServiceAddOn = undefined;
            scheduleService.serviceAddOns = [];
            if (scheduleService.service) {
                scheduleService.serviceId = scheduleService.service.id;
                this.getSteps([scheduleService]);
                if (this.model.client) {
                    this.checkServiceAndClientGenderConflict(false, [scheduleService]);
                }
            }
            else {
                scheduleService.serviceId = undefined;
            }
            this.updateEmployeeCriteria(scheduleService);
        }

        updateEmployeeCriteria(scheduleService) {
            if (scheduleService.service) {
                scheduleService.employeeCriteria = { showEmployeesOnly: true, serviceIdList: [scheduleService.service.id] };
            } else {
                scheduleService.employeeCriteria = { showEmployeesOnly: true };
            }
        }

        checkServiceAndClientGenderConflict(clientChanged, scheduleServices) {
            let messages = [];
            let invalidScheduleServices = [];
            scheduleServices.forEach((scheduleService) => {
                // does not matter if service is available for both male and female, or both are not set
                if (scheduleService.service && scheduleService.service.availableForMale != scheduleService.service.availableForFemale) {
                    if ((scheduleService.service.availableForMale && this.model.client.gender != Model.GenderEnum.Male) ||
                        (scheduleService.service.availableForFemale && this.model.client.gender != Model.GenderEnum.Female)) {
                        messages.push({message: this.$translate.instant("MESSAGE_SERVICE_AND_CLIENT_GENDER_CONFLICT_WARNING",
                            { serviceDisplayName: scheduleService.service.displayName })
                        });
                        invalidScheduleServices.push(scheduleService);
                    }
                }
            });
            if (messages.length > 0) {
                this.appointmentBookModalService.showMessages(messages, "HEADER_STANDING_APPOINTMENT_WARNING", {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    callback: (response) => {
                        if (response === Meevo.Model.MessageBoxButtonResult.No) {
                            scheduleServices.forEach((scheduleService) => {
                                scheduleService.service = undefined;
                            });
                        }
                    }
                });
            }
        }

        employeeChanged(scheduleService) {
            scheduleService.steps = undefined;
            if (scheduleService.service) {
                this.getSteps([scheduleService]);
            }
        }

        getSteps(scheduleServices) {
            let validServices: any = _(scheduleServices).filter((service => {
                return service.service; // && service.employee;
            }));

            if (validServices.length === 0) {
                return;
            }

            if (validServices.length === 1) {
                this.restServer.getAppointmentServiceTemplateWithAddOns(
                    (validServices[0].employee || {}).id,
                    validServices[0].service.id,
                    (this.model.client || {}).id,
                    _(validServices[0].serviceAddOn).pluck("addOnServiceId"),
                    undefined,
                    (response) => {
                        validServices[0].serviceAlerts = [];
                        validServices[0].service.doNotAllowStepTimingOverride = response.doNotAllowStepTimingOverride;
                        validServices[0].isEnableIntelliBooking = response.isEnableIntelliBooking;
                        if (!angular.isDefined(validServices[0].hasServiceAddOn) && this.serviceAddOnPermission && response.hasServiceAddOn) {
                            //Timeout for the time it takes the typeahead dropdown to close and the mobile keyboard to disappear
                            this.$timeout(() => {
                                this.showServiceAddOns(validServices[0], true);
                            }, 500);
                        }
                        validServices[0].hasServiceAddOn = response.hasServiceAddOn;
                        if (validServices[0].employee && !response.employeePerformsService)
                            validServices[0].serviceAlerts.push(<PassiveAlert>{
                                alertMessage: this.$translate.instant("MESSAGE_EMPLOYEE_DOES_NOT_PERFORM_SERVICE"),
                                alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.Normal
                            });

                        this.updateSteps(validServices[0], response.steps);
                        validServices[0].hasResource = _(response.resources).any();
                    });
            } else {
                if (!this.model.client) {
                    return;
                }

                const request = {
                    employeeServiceIds: _(validServices).map(service => {
                        return {
                            serviceId: service.service.id,
                            employeeId: service.employee.id,
                            clientId: this.model.client.id,
                        }
                    }),
                };

                this.dataService.customMethodData(`/api/appointmentservice/templatelist`, "post", request).then(response => {
                    validServices.forEach(validService => {
                        let template = _(response.data).findWhere({
                            employeeId: (validService.employee || {}).id,
                            serviceId: validService.service.id
                        });

                        this.updateSteps(validService, template.steps);
                        validService.hasResource = _(response.resources).any();
                    });
                });
            }
        }

        updateSteps(scheduleService, steps) {
            scheduleService.steps = [];
            for (let step of steps) {
                scheduleService.steps.push({
                    serviceStepId: step.serviceStepId,
                    durationInMinutes: step.durationInMinutes,
                    extendedByStepMinutes: step.extendedByStepMinutes,
                    durationWithAddOnsInMinutes: step.durationWithAddOnsInMinutes,
                    defaultDurationInMinutes: step.defaultDurationInMinutes,
                    serviceStepType: step.serviceStepType,
                    serviceStepDisplayName: step.serviceStepDisplayName,
                    serviceStepTypeDisplayName: step.serviceStepTypeDisplayName,
                    isCleanupStep: step.isCleanupStep,
                    includeInProductivity: step.includeInProductivity
                });
            }
            this.stepOverrideService.initializeStage(scheduleService);
        }

        isDeleted(): boolean {
            return this.model && this.model.objectState && this.model.objectState === Model.ObjectStateEnum.Deleted;
        }
        showChangeLog() {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/AppointmentAuditLog.html",
                controller: "AppointmentAuditLogController",
                bindToController: true,
                locals: {
                    appointmentServiceScheduleId: this.model.id,
                    appointmentId: undefined,
                    appointmentRequestId: undefined
                }
            }
            this.modalService.showCustom(options);
        }
        showSteps(serviceSchedule) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/AppointmentBookSteps.html",
                controller: "meevo.plugins.standingAppointments.StepsModalController",
                bindToController: true,
                locals: {
                    serviceSchedule: serviceSchedule,
                    isReadOnly: this.mode == Meevo.Model.MaintenanceFormState.Readonly || this.context.isBlockedFromEditing,
                    client: this.model.client
                }
            }
            this.modalService.showCustom(options);
        }

        showServiceAddOns(serviceSchedule: Meevo.Model.AppointmentServiceSchedule, isAutomated: boolean = false) {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/AppointmentBook/views/serviceAddOns.html",
                controller: "meevo.plugins.appointmentBook.ServiceAddOnsController",
                bindToController: true,
                locals: {
                    serviceId: serviceSchedule.service.id,
                    numRequiredAddOns: serviceSchedule.service.numRequiredAddOns,
                    employeeId: serviceSchedule.employee.id,
                    currentServiceAddOns: serviceSchedule.serviceAddOns,
                    finalState: Model.AppointFinalStateEnum.None,
                    transitionState: Model.AppointStateEnum.Booked,
                    isReadOnly: this.mode == Meevo.Model.MaintenanceFormState.Readonly || this.context.isBlockedFromEditing,
                    isFromWalkIn: false,
                    clientId: this.model.client ? this.model.client.id : null,
                    serviceDisplayName: serviceSchedule.service.displayName,
                    isAutomated: isAutomated,
                    equipmentValidator: null,
                    yieldManagementDateTime: undefined,
                    applyProductUsage: false,
                    appointmentServiceId: undefined
                },
                controllerAs: "vm"
            };

            this.modalService.showCustom(options, Components.Modal.ModalTranslationModes.DoNotTranslate, true).then(response => {
                switch (response.action) {
                    case 'save':
                        const addOns = response.data;
                        addOns.forEach(addOn => {
                            addOn.appointmentScheduleServiceId = serviceSchedule.id;
                        });
                        serviceSchedule.serviceAddOns = addOns;
                        break;
                    case 'close':
                    case 'cancel':
                        const hasRequired = response.data;
                        if (isAutomated && hasRequired) {
                            serviceSchedule.service = undefined;
                            this.serviceChanged(serviceSchedule);
                        }
                        break;
                }
                this.calculateStepDuration(serviceSchedule);
            })
        }

        private calculateStepDuration(appointmentService) {
            this.stepOverrideService.calculateStepDuration(appointmentService);
        }

        deleteService(index) {
            this.model.services.splice(index, 1);
        }

        addService() {
            let scheduleService: Model.AppointmentServiceSchedule = {
                isRequested: true
            };
            this.updateEmployeeCriteria(scheduleService);
            (<any>scheduleService).manualStartTimeTemp = moment("09:00", "HH:mm").toDate();

            this.model.services.push(scheduleService);
        }

        employeeRequired(serviceSchedule = undefined) {
            if (!serviceSchedule || !serviceSchedule.service) {
                return false;
            }
            let isResource = serviceSchedule.hasResource ||
                _(serviceSchedule.steps).any(step =>
                    step.durationWithAddOnsInMinutes > 0 &&
                    step.serviceStepType == Meevo.Model.ServiceStepTypeEnum.Resource);
            return !isResource;
        }
    }
}